<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/dropper.svg" style="width:20px" />
            Drug Master
          </p>
        </CCardHeader>
        <c-card-body>
          <CDataTable
           :items="drugItem"
            :fields="fields"
            table-filter
            items-per-page-select
            :items-per-page="10"
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Breed"
          />
          </c-card-body>
      </CCard>
    </CCol>
    <CCol col="12" md="5">
      <CCard>
       <c-card-body>
          <CTabs add-tab-classes="mt-1">
            <CTab>
              <template slot="title">
                <img src="img/dropper.svg" style="width:20px" />
                {{tabs[0]}}
              </template>
              <CCard>
                <CCardBody>
                  <CForm>
                    <CInput
                      label="medicineCode"
                      horizontal
                      autocomplete="name"
                      v-model="medicineCode"
                    />

                    <CInput
                      label="medicineName"
                      horizontal
                      autocomplete="name"
                      v-model="medicineName"
                    />
                    <CInput
                      label="genericName"
                      horizontal
                      autocomplete="name"
                      v-model="genericName"
                    />
                    <div class="row">
                      <div class="col-sm-4">MedicineType</div>
                      <div class="col-sm-8">
                        <!-- <Vselect :options="second" v-model="medicineType" searchable /> -->
                          <CInput  horizontal autocomplete="name" v-model="medicineType" /> 
                      </div>
                    </div>

                    <!-- <CInput label="Address" horizontal autocomplete="name" v-model="units" /> -->

                    <br />
                    <div class="row">
                      <div class="col-sm-4">Units</div>
                      <div class="col-sm-8">
                        <!-- <Vselect :options="Districtoptions" v-model="Units" searchable /> -->
                             <CInput  horizontal autocomplete="name" v-model="units" /> 
                      </div>
                    </div>
                    <br />

                    <div class="row">
                      <div class="col-sm-4">Route</div>
                      <div class="col-sm-8">
                        <!-- <Vselect :options="second" v-model="route" searchable /> -->
                             <CInput  horizontal autocomplete="name" v-model="route" /> 
                      </div>
                    </div>
                    <br />

                    <CInput label="Rate" horizontal autocomplete="name" v-model="rate" />

                    <CInput
                      label="Opening Amount"
                      horizontal
                      autocomplete="name"
                      v-model="openingAmount"
                    />

                    <CInput
                      label="withdrawPeriod"
                      horizontal
                      autocomplete="name"
                      v-model="withdrawPeriod"
                    />
                    <br />
                    <CRow>
                      <CCol md="3">
                        <h5 style="font-size:15px">Allow all user</h5>
                      </CCol>
                      <CCol md="3">
                        <input type="checkbox" id="status" v-model="Allowalluser" value="on" />
                        <!-- <CSwitch
                        class="mx-1"
                        color="primary"
                        checked
                        variant="opposite"
                        style="width:50px"
                        shape="pill"
                        v-bind="labelTxt"
                         name="allowAllUser"
                id="allowAllUser"
                required
                        />-->
                      </CCol>

                      <CCol md="3">
                        <h5 style="font-size:15px">Suspend</h5>
                      </CCol>
                      <CCol md="3">
                        <!-- <CSwitch
                        class="mx-1"
                        color="primary"
                        checked
                        variant="opposite"
                        style="width:50px"
                        shape="pill"
                        v-bind="labelTxt"
                          name="suspend"
                id="suspend"
                required
                        />-->
                        <input type="checkbox" id="status" v-model="suspend" value="on" />
                      </CCol>
                    </CRow>
                    <br />
                    <br />
                    <CRow>
                      <CCol md="3">
                        <h5 style="font-size:15px">Govt Medicine</h5>
                      </CCol>
                      <CCol md="3">
                        <!-- <CSwitch
                        class="mx-1"
                        color="primary"
                        checked
                        variant="opposite"
                        style="width:50px"
                        shape="pill"
                        v-bind="labelTxt"
   name="govtMedicine"
                id="govtMedicine"
                required
                        />-->
                        <input type="checkbox" id="status" v-model="govtMedicine" value="on" />
                      </CCol>

                      <CCol md="6">
                        <p style="font-size:15px">Difference in Opening balance : 0</p>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
                <CCardFooter>
                  <CButton color="info" style="width:100px" v-if="addButton" @click="addSociety">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="saveButton"
                    @click="updateRoute"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="danger"
                    style="width:100px"
                    v-if="deleteButton"
                    @click="deleteRoute"
                  >
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="EditsaveButton"
                    @click="addSociety"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="CancelRoute"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton>&nbsp;
                  <CButton color="info" v-if="addnewButton" @click="addRouteplus">
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
                </CCardFooter>
               
              </CCard>
            </CTab>
            <CTab>
              <template slot="title">
                <img src="img/dropper (1).svg" style="width:20px" />
                {{tabs[1]}}
              </template>
              <c-card>
                <c-card-body>
                  <CTableWrapper
                    :fields="fields1"
                    hover
                    striped
                    bordered
                    small
                    fixed
                    caption="Breed"
                  ></CTableWrapper>
                </c-card-body>
              </c-card>
            </CTab>
          </CTabs>
        </c-card-body>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { Vselect } from "@/components";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper, Vselect },

  data() {
    return {
      drugItem:[],
      drugedit:[],
      medicineCode: null,
      medicineName: "",
      genericName: "",
      medicineType: "",
      units: "",
      route: "",
      rate: "",
      openingAmount: "",
      withdrawPeriod: "",
      Allowalluser: false,
      suspend: false,
      govtMedicine: false,
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,

      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      tabs: ["DrugMaster Details", "Dosage"],
      fields: [
        {
          key: "medicineCode",
          sortable: true
        },
        {
          key: "medicineName",
          sortable: true
        },
        {
          key: "genericName",
          sortable: true
        },
        {
          key: "medicineType",
          sortable: true
        },
        {
          key: "units",
          sortable: true
        },
        {
          key: "route",
          sortable: true
        },
        {
          key: "openingAmount",
          sortable: true
        },
        {
          key: "withdrawPeriod",
          sortable: true
        },
        {
          key: "Allowalluser",
          sortable: true
        },
        {
          key: "suspend",
          sortable: true
        },
        {
          key: "govtMedicine",
          sortable: true
        }
      ],
      items: [
        {
          isActive: true,
          Drug_code: "20000099",
          Drug_Name: "Antimony Pottasium Tartarate",
          Drug_Type: "Oral Drugs"
        },
        {
          isActive: true,
          Drug_code: "20000222",
          Drug_Name: "Diphenhydramine Hcl",
          Drug_Type: "Anti TussiV"
        },
        {
          isActive: true,
          Drug_code: "20000048",
          Drug_Name: "Neyomycin + Doxycycline",
          Drug_Type: "Oral Antibi"
        },
        {
          isActive: true,
          Drug_code: "200000105",
          Drug_Name: "Activated Charcoal",
          Drug_Type: "Oral Drugs"
        },
        {
          isActive: true,
          Drug_code: "200000200",
          Drug_Name: "Addrenochrome",
          Drug_Type: "Styptic"
        },
        {
          isActive: true,
          Drug_code: "20000099",
          Drug_Name: "Antimony Pottasium Tartarate",
          Drug_Type: "Oral Drugs"
        },
        {
          isActive: true,
          Drug_code: "20000222",
          Drug_Name: "Diphenhydramine Hcl",
          Drug_Type: "Anti TussiV"
        },
        {
          isActive: true,
          Drug_code: "20000048",
          Drug_Name: "Neyomycin + Doxycycline",
          Drug_Type: "Oral Antibi"
        },
        {
          isActive: true,
          Drug_code: "200000105",
          Drug_Name: "Activated Charcoal",
          Drug_Type: "Oral Drugs"
        },
        {
          isActive: true,
          Drug_code: "200000200",
          Drug_Name: "Addrenochrome",
          Drug_Type: "Styptic"
        }
      ],
      fields1: [
        {
          key: "NO",
          sortable: true
        },
        {
          key: "Species",
          sortable: true
        },
        {
          key: "Dosage",
          sortable: true
        }
      ]
    };
  },
  methods: {
    getdurgMasterList() {
      APIService.durgMasterList().then(res => {
        if (res.status == 200) {
          this.drugItem = res.data;
         

         this.medicineCode = this.drugItem[0].medicineCode;
      this.medicineName = this.drugItem[0].medicineName;
      this.genericName = this.drugItem[0].genericName;
      this.medicineType = this.drugItem[0].medicineType;
      this.units = this.drugItem[0].units;
      this.route = this.drugItem[0].route;
      this.union = this.drugItem[0].union;
      this.route =this.drugItem[0].route;
      this.rate = this.drugItem[0].rate;
      this.openingAmount =this.drugItem[0].openingAmount;
      this.withdrawPeriod =this.drugItem[0].withdrawPeriod;
      this.Allowalluser =this.drugItem[0].Allowalluser;
      this.suspend = this.drugItem[0].suspend;
      this.govtMedicine =this.drugItem[0].govtMedicine;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.drugedit = item;
      this.medicineCode = item.medicineCode;
      this.medicineName = item.medicineName;
      this.genericName = item.genericName;
      this.medicineType = item.medicineType;
      this.units = item.units;
      this.route = item.route;
      this.union = item.union;
      this.route = item.route;
      this.rate = item.rate;
      this.openingAmount = item.openingAmount;
      this.withdrawPeriod = item.withdrawPeriod;
      this.Allowalluser = item.Allowalluser;
      this.suspend = item.suspend;
      this.govtMedicine = item.govtMedicine;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addSociety() {
      let id = this.drugedit._id;
      let medicineCode = this.medicineCode;
      let medicineName = this.medicineName;
      let genericName = this.genericName;
      let medicineType = this.medicineType;
      let units = this.units;
      let rate = this.rate;
      let route = this.route;
      let openingAmount = this.openingAmount;
      let withdrawPeriod = this.withdrawPeriod;
      let Allowalluser = this.Allowalluser;
      let suspend = this.suspend;
      let govtMedicine = this.govtMedicine;

      let data = {
        medicineCode,
        medicineName,
        genericName,
        medicineType,
        units,
        route,
        rate,
        openingAmount,
        withdrawPeriod,
        Allowalluser,
        suspend,
        govtMedicine
      };
      APIService.saveDurgMaster(data).then(res => {
        if (res.status == 200) {
          this.medicineCode = null;
          this.medicineName = "";
          this.genericName = "";
          this.medicineType = "";
          this.units = "";
          this.rate = "";
          this.union = "";
          this.route = "";
          this.openingAmount = "";
          this.withdrawPeriod = "";
          this.Allowalluser = "";
          this.suspend = "";
          this.govtMedicine = "";
         this.getdurgMasterList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    addRouteplus() {
      this.medicineCode = null;
      this.medicineName = "";
      this.genericName = "";
      this.medicineType = "";
      this.units = "";
      this.rate = "";
      this.union = "";
      this.route = "";
      this.openingAmount = "";
      this.withdrawPeriod = "";
      this.Allowalluser = "";
      this.suspend = "";
      this.govtMedicine = "";
      this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true), this.getdurgMasterList();
    },

    CancelRoute() {
      this.farmerId = null;
      this.medicineCode = null;
      this.medicineName = "";
      this.genericName = "";
      this.medicineType = "";
      this.units = "";
      this.rate = "";
      this.union = "";
      this.route = "";
      this.openingAmount = "";
      this.withdrawPeriod = "";
      this.Allowalluser = "";
      this.suspend = "";
      this.govtMedicine = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getdurgMasterList();
    },
    updateRoute() {
      let id = this.drugedit._id;
      let medicineCode = this.medicineCode;
      let medicineName = this.medicineName;
      let genericName = this.genericName;
      let medicineType = this.medicineType;
      let units = this.units;
      let rate = this.rate;
      let route = this.route;
      let openingAmount = this.openingAmount;
      let withdrawPeriod = this.withdrawPeriod;
      let Allowalluser = this.Allowalluser;
      let suspend = this.suspend;
      let govtMedicine = this.govtMedicine;
      let value = {
        medicineCode,
        medicineName,
        genericName,
        medicineType,
        units,
        route,
        rate,
        openingAmount,
        withdrawPeriod,
        Allowalluser,
        suspend,
        govtMedicine
      };
      let data = { id, value };
      APIService.durgMasterUpdate(data).then(res => {
        if (res.status == 200) {
          this.medicineCode = null;
          this.medicineName = "";
          this.genericName = "";
          this.medicineType = "";
          this.units = "";
          this.rate = "";
          this.union = "";
          this.route = "";
          this.openingAmount = "";
          this.withdrawPeriod = "";
          this.Allowalluser = "";
          this.suspend = "";
          this.govtMedicine = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
           this.getdurgMasterList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    delete() {
      let id = this.drugedit._id;
      let data = { id };
      APIService.durgMasterDelete(data).then(res => {
        if (res.status == 200) {
          this.medicineCode = null;
          this.medicineName = "";
          this.genericName = "";
          this.medicineType = "";
          this.units = "";
          this.rate = "";
          this.union = "";
          this.route = "";
          this.openingAmount = "";
          this.withdrawPeriod = "";
          this.Allowalluser = "";
          this.suspend = "";
          this.govtMedicine = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getdurgMasterList();
        }
      });
    }
  },
  created() {
this.getdurgMasterList();

  }
};
</script>
